import React from "react";
import PropTypes from "prop-types";
import { Marker as LeafletMarker } from "react-leaflet";

import { activeIcon, normalIcon, unapprovedIcon } from "../utils/map-icons";

const get_icon = (isActive, isApproved) => {
  if (isActive) {
    return activeIcon;
  }
  if (!isApproved) {
    return unapprovedIcon;
  }
  return normalIcon;
};

const Marker = props => {
  const {
    institution: {
      _key,
      approved,
      geo: { lat, lng }
    },
    isActive,
    name,
    onClick,
    onAdd
  } = props;
  const icon = get_icon(isActive, approved);

  if (!lat || !lng) {
    return null;
  }

  return (
    <LeafletMarker
      position={[lat, lng]}
      institution_id={_key}
      onClick={marker => onClick(marker.target.options.institution_id)}
      icon={icon}
      riseOnHover={true}
      onMouseOver={marker => marker.target.openPopup()}
      onMouseOut={marker => !isActive && marker.target.closePopup()}
      title={name}
      onAdd={element => onAdd(element)}
    >
      {props.children}
    </LeafletMarker>
  );
};

Marker.propTypes = {
  institution: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  onAdd: PropTypes.func
};

export default Marker;



/** WEBPACK FOOTER **
 ** ./src/components/Marker.jsx
 **/